import React, { useState } from "react";

import { useParams } from "react-router-dom";

import {
  HouseholdAccountTypePagination,
  HouseholdId,
} from "@fartherfinance/frontend/api/Households/types";

import { getHouseholdAccountType } from "../../helpers";
import HouseholdAccountsTable from "../HouseholdAccountsTable/HouseholdAccountsTable";
import { useGetHouseholdAccountsFilter } from "@src/multiCustodian/components/Advisor/Households/hooks/useGetHouseholdAccountsFilter";
import useAdvisorRequestAuth from "@src/multiCustodian/hooks/useAdvisorRequestAuth";

import styles from "../HouseholdAccountsTable/HouseholdAccountsTable.module.css";

const HouseholdAccountsTables: React.FC = () => {
  const { householdId } = useParams<{ householdId: HouseholdId }>();
  const [paginationState, setPaginationState] = useState<
    Record<string, number>
  >({});

  const auth = useAdvisorRequestAuth();

  const handleOnPageChange = (
    page: number,
    accountType: HouseholdAccountTypePagination
  ) => {
    setPaginationState((prev) => ({
      ...prev,
      [accountType]: page,
    }));
  };

  const {
    fartherAccounts,
    manualAccounts,
    creditAccounts,
    depositoryAccounts,
    investmentAccounts,
    loanAccounts,
    savingsAccounts,
    checkingAccounts,
    otherExternalAccounts,
    isLoading: isLoadingAccounts,
  } = useGetHouseholdAccountsFilter(householdId, paginationState, auth);

  const accountTables = [
    fartherAccounts,
    manualAccounts,
    creditAccounts,
    depositoryAccounts,
    investmentAccounts,
    loanAccounts,
    savingsAccounts,
    checkingAccounts,
    otherExternalAccounts,
  ].filter((accounts) => accounts.data.length > 0);

  return (
    <div className={styles.tablesContainer}>
      {accountTables.map((accounts, index) => {
        const accountType = getHouseholdAccountType(accounts.data[0]);
        const currentPage = paginationState[accountType] || 1;

        return (
          <div key={index}>
            <HouseholdAccountsTable
              isLoading={isLoadingAccounts}
              pagination={accounts.pagination}
              accounts={accounts.data}
              currentPage={currentPage}
              accountType={accountType}
              handleOnPageChange={handleOnPageChange}
            />
            {index < accountTables.length - 1 && (
              <div className={styles.tableSpacing} />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default HouseholdAccountsTables;
